import { defineMessages } from '@edx/frontend-platform/i18n';

const messages = defineMessages({
  // institution login strings
  'institution.login.page.sub.heading': {
    id: 'institution.login.page.sub.heading',
    defaultMessage: 'Choose your institution from the list below',
    description: 'Heading of the institutions list',
  },
  // logistration strings
  'logistration.sign.in': {
    id: 'logistration.sign.in',
    defaultMessage: 'Sign in',
    description: 'Text that appears on the tab to switch between login and register',
  },
  'logistration.register': {
    id: 'logistration.register',
    defaultMessage: 'Register',
    description: 'Text that appears on the tab to switch between login and register',
  },
  'logistration.first.time.here': {
    id: 'logistration.first.time.here',
    defaultMessage: 'First time here?',
    description: '',
  },
  'logistration.already.have.an.account': {
    id: 'logistration.already.have.an.account',
    defaultMessage: 'Already have an account?',
    description: '',
  },
  'logistration.sign.in.link': {
    id: 'logistration.sign.in.link',
    defaultMessage: 'Sign in',
    description: '',
  },
  'logistration.create.an.account.link': {
    id: 'logistration.create.an.account.link',
    defaultMessage: 'Create an Account',
    description: '',
  },
  'logistration.create.account.title': {
    id: 'logistration.create.account.title',
    defaultMessage: 'Create Account',
    description: '',
  },
  'register.required.remark': {
    id: 'register.required.remark',
    defaultMessage: 'Required',
    description: '',
  },
  'back.button': {
    id: 'back.button',
    defaultMessage: 'Back',
    description: '',
  },
  'max.email.failed.attempts.text': {
    id: 'max.email.failed.attempts.text',
    defaultMessage: 'Still not receiving it? Check {spam} or try again in a few minutes. {enter} Need help? Contact {support}',
    description: '',
  },
  'max.email.failed.attempts.spam.folder': {
  id: 'max.email.failed.attempts.spam.folder',
  defaultMessage: 'Spam/Junk',
  description: '',
  },
  'max.email.failed.attempts.technical.support.link': {
    id: 'max.email.failed.attempts.technical.support.link',
    defaultMessage: 'support',
    description: '',
  },
  'password.strength.the.password.must.include': {
    id: 'password.strength.the.password.must.include',
    defaultMessage: 'Your password must include:',
    description: '',
  },
  'password.strength.text.weakness.level.one': {
    id: 'password.strength.text.weakness.level.one',
    defaultMessage: 'Weak password',
    description: '',
  },
  'password.strength.text.weakness.level.two': {
    id: 'password.strength.text.weakness.level.two',
    defaultMessage: 'Fair password',
    description: '',
  },
  'password.strength.text.weakness.level.three': {
    id: 'password.strength.text.weakness.level.three',
    defaultMessage: 'Good password',
    description: '',
  },
  'password.strength.text.weakness.level.four': {
    id: 'password.strength.text.weakness.level.four',
    defaultMessage: 'Strong password!',
    description: '',
  },
  'password.strength.only.english.letters.validation': {
    id: 'password.strength.only.english.letters.validation',
    defaultMessage: 'English characters only',
    description: '',
  },
  'password.strength.one.uppercase.validation': {
    id: 'password.strength.one.uppercase.validation',
    defaultMessage: 'One uppercase letter (A-Z)',
    description: '',
  },
  'password.strength.one.lowercase.validation': {
    id: 'password.strength.one.lowercase.validation',
    defaultMessage: 'One lowercase letter (a-z)',
    description: '',
  },
  'password.strength.minimum.letters.validation': {
    id: 'password.strength.minimum.letters.validation',
    defaultMessage: 'At least {minLength} characters',
    description: '',
  },
  'password.strength.not.match.validation': {
    id: 'password.strength.not.match.validation',
    defaultMessage: 'Passwords must match',
    description: '',
  },
  'password.strength.at.least.one.special.or.number.validation': {
    id: 'password.strength.at.least.one.special.or.number.validation',
    defaultMessage: 'At least one special character or number',
    description: '',
  },
  'password.strength.at.least.one.special.character.validation': {
    id: 'password.strength.at.least.one.special.character.validation',
    defaultMessage: 'One special character (like !, $, @, #)',
    description: '',
  },
  'password.strength.at.least.one.number.validation': {
    id: 'password.strength.at.least.one.number.validation',
    defaultMessage: 'At least one number',
    description: '',
  },
  'information.cards.first.title': {
    id: 'information.cards.first.title',
    defaultMessage: 'Practical tools for the digital labor market',
    description: '',
  },
  'information.cards.first.description': {
    id: 'information.cards.first.description',
    defaultMessage: 'Arrive at a job interview or office with the skills relevant to the modern job market. A wide range of courses tailored to the changing demands of the digital economy.',
    description: '',
  },
  'information.cards.second.title': {
    id: 'information.cards.second.title',
    defaultMessage: 'An innovative learning experience with experiential activities',
    description: '',
  },
  'information.cards.second.description': {
    id: 'information.cards.second.description',
    defaultMessage: 'Video courses, forums, and interactive tools - without leaving home. Be part of a dynamic and supportive student community, and face the challenges of the future together.',
    description: '',
  },
  'information.cards.third.title': {
    id: 'information.cards.third.title',
    defaultMessage: 'A variety of areas for personal and professional development',
    description: '',
  },
  'information.cards.third.description': {
    id: 'information.cards.third.description',
    defaultMessage: 'Discover fascinating topics, from computer science to art and psychology. A great opportunity for career change, advancement at work, or enriching your knowledge.',
    description: '',
  },
  'information.cards.fourth.title': {
    id: 'information.cards.fourth.title',
    defaultMessage: 'Online academic courses with a certificate - free of charge!',
    description: '',
  },
  'information.cards.fourth.description': {
    id: 'information.cards.fourth.description',
    defaultMessage: 'Learn at your own pace, at a time that suits you, directly from your computer or mobile. A variety of courses that broaden your horizons and open up new career opportunities.',
    description: '',
  },
  // enterprise sso strings
  'enterprisetpa.title.heading': {
    id: 'enterprisetpa.title.heading',
    defaultMessage: 'Would you like to sign in using your {providerName} credentials?',
    description: 'Header text used in enterprise third party authentication',
  },
  'enterprisetpa.login.button.text': {
    id: 'enterprisetpa.login.button.text',
    defaultMessage: 'Show me other ways to sign in or register',
    description: 'Button text for login',
  },
  'enterprisetpa.login.button.text.public.account.creation.disabled': {
    id: 'enterprisetpa.login.button.text.public.account.creation.disabled',
    defaultMessage: 'Show me other ways to sign in',
    description: 'Button text for login when account creation is disabled',
  },
  // social auth providers
  'sso.sign.in.with': {
    id: 'sso.sign.in.with',
    defaultMessage: 'Sign in with {providerName}',
    description: 'Screen reader text that appears before social auth provider name',
  },
  'provider.google':  { 
    id: 'provider.google',
    defaultMessage: 'Google'
  },
  'provider.facebook': { 
    id: 'provider.facebook', 
    defaultMessage: 'Facebook'
 },
  'provider.nis': { 
    id: 'provider.nis', 
    defaultMessage: 'IDP'
 },
  'provider.edu': { 
    id: 'provider.edu', 
    defaultMessage: 'Ministry of Education'
 },
   'provider.moe': { 
    id: 'provider.moe', 
    defaultMessage: 'Ministry of Education'
 },
  'provider.generic': { 
    id: 'provider.generic', 
    defaultMessage: '{providerName}'
 },
  'sso.create.account.using': {
    id: 'sso.create.account.using',
    defaultMessage: 'Create account using {providerName}',
    description: 'Screen reader text that appears before social auth provider name',
  },
  // password field strings
  'show.password': {
    id: 'show.password',
    defaultMessage: 'Show password',
    description: 'aria label for show password icon on password field',
  },
  'hide.password': {
    id: 'hide.password',
    defaultMessage: 'Hide password',
    description: 'aria label for hide password icon on password field',
  },
  'one.letter': {
    id: 'one.letter',
    defaultMessage: '1 letter',
    description: 'password requirement to have 1 letter',
  },
  'one.number': {
    id: 'one.number',
    defaultMessage: '1 number',
    description: 'password requirement to have 1 number',
  },
  'eight.characters': {
    id: 'eight.characters',
    defaultMessage: '8 characters',
    description: 'password requirement to have a minimum of 8 characters',
  },
  'password.sr.only.helping.text': {
    id: 'password.sr.only.helping.text',
    defaultMessage: 'Password must contain at least 8 characters, at least one letter, and at least one number',
    description: 'Password helping text for the sr-only class',
  },
  // third party auth
  'tpa.alert.heading': {
    id: 'tpa.alert.heading',
    defaultMessage: 'Almost done!',
    description: 'Success alert heading after user has successfully signed in with social auth',
  },
  'login.third.party.auth.account.not.linked': {
    id: 'login.third.party.auth.account.not.linked',
    defaultMessage: 'You have successfully signed into {currentProvider}, but your {currentProvider} '
                    + 'account does not have a linked {platformName} account. To link your accounts, '
                    + 'sign in now using your {platformName} password.',
    description: 'Message that appears on login page if user has successfully authenticated with social '
                  + 'auth but no associated platform account exists',
  },
  'register.third.party.auth.account.not.linked': {
    id: 'register.third.party.auth.account.not.linked',
    defaultMessage: 'You\'ve successfully signed into {currentProvider}! We just need a little more information '
                    + 'before you start learning with {platformName}.',
    description: 'Message that appears on register page if user has successfully authenticated with TPA '
                  + 'but no associated platform account exists',
  },
  'registration.using.tpa.form.heading': {
    id: 'registration.using.tpa.form.heading',
    defaultMessage: 'Finish creating your account',
    description: 'Heading that appears above form when user is trying to create account using social auth',
  },
  supportTitle: {
    id: 'zendesk.supportTitle',
    description: 'Title for the support button',
    defaultMessage: 'edX Support',
  },
  selectTicketForm: {
    id: 'zendesk.selectTicketForm',
    description: 'Select ticket form',
    defaultMessage: 'Please choose your request type:',
  },
  'separator.or.text': {
    id: 'separator.or.text',
    defaultMessage: 'Or',
    description: '',
  },
});

export default messages;
